<dxp-message-list *ngIf="isToasterVisible">
    <dxp-message severity="success" close-button=true close-button-title="Close button!"
      *ngIf="showSuccessToaster" (closed)="hideToaster($event)">
      <dxp-message-text text="{{this.notificationMessage}}"></dxp-message-text>
    </dxp-message>
    <dxp-message severity="error" close-button=true close-button-title="Close button!"
      *ngIf="showErrorToaster" (closed)="hideToaster($event)">
      <dxp-message-text text="{{this.notificationMessage}}"></dxp-message-text>
    </dxp-message>
    <dxp-message severity="info" close-button=true close-button-title="Close button!"
      *ngIf="showInfoToaster" (closed)="hideToaster($event)">
      <dxp-message-text text="{{this.notificationMessage}}"></dxp-message-text>
    </dxp-message>
    <dxp-message severity="warn" close-button=true close-button-title="Close button!"
      *ngIf="showWarnToaster" (closed)="hideToaster($event)">
      <dxp-message-text text="{{this.notificationMessage}}"></dxp-message-text>
    </dxp-message>
</dxp-message-list>

